import { RecetaRequestModel } from '../models/store.model';
import * as fromActions from '../actions/receta.action';

export const recetaInitialState: RecetaRequestModel | null = null;

export function recetaDataReducer(
    state = recetaInitialState,
    action: fromActions.RecetaActions
): RecetaRequestModel | null {
    switch (action.type) {
        case fromActions.SET_RECETA_REQUEST:
            return { ...state, ...action.payload };
        case fromActions.UNSET_RECETA_REQUEST:
            return recetaInitialState;
        default:
            return state;
    }
}
